import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Navigation, NavList, NavItem, NavLink } from "../styles/StyledComponents";

const NavigationComponent = () => {
  const history = useHistory();
  const location = useLocation();

  const navItems = [
    { path: "/", label: "متابعة حالة طلب النقل المدرسي" },
    { path: "/submit", label: "تقديم بلاغ جديد" },
    { path: "/search", label: "البحث عن البلاغ" },
  ];

  const handleNavigation = (path) => {
    history.push(path);
  };

  return (
    <Navigation>
      <NavList>
        {navItems.map((item) => (
          <NavItem key={item.path}>
            <NavLink
              active={location.pathname === item.path}
              onClick={() => handleNavigation(item.path)}
            >
              {item.label}
            </NavLink>
          </NavItem>
        ))}
      </NavList>
    </Navigation>
  );
};

export default NavigationComponent;
